module.exports = __webpack_public_path__ + "static/media/1009778.583507f8.jpg";